/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const challengeInitiateBodyExpectedVersionExclusiveMin = 0;
export const challengeInitiateBodyExpectedVersionMax = 9007199254740991;

export const ChallengeInitiateBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(challengeInitiateBodyExpectedVersionExclusiveMin)
    .max(challengeInitiateBodyExpectedVersionMax),
  transport: zod.enum(['email-link', 'sms-code', 'voice-code']),
});

export type ChallengeInitiateBody = zod.input<typeof ChallengeInitiateBody>;
export type ChallengeInitiateBodyOutput = zod.output<typeof ChallengeInitiateBody>;
